<template>
  <div :class="$style.reports">
    <projects-report-page
      v-if="type === 'project'"
      :report-type="'budget'"
    />
    <monthes-report-page
      v-if="type === 'month'"
      :report-type="'budget'"
    />
    <report-by-resource-page
      v-if="type === 'resource'"
      :report-type="'budget'"
    />
  </div>
</template>

<script>
import monthesReportPage from './reportByMonthMainPage.vue';
import projectsReportPage from './reportByProjectsMainPage.vue';
import reportByResourcePage from './reportsByResourceMainPage.vue';

export default {
  components: {
    monthesReportPage, projectsReportPage, reportByResourcePage
  },
  data() {
    return {
      type: null,
      locales: __,
    };
  },
  mounted() {
    if (['project', 'month', 'resource'].includes(this.$route.params?.type)) {
      this.type = this.$route.params?.type;

      return;
    }

    this.$router.push({ name: 'reports' });
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
